<template>
  <div class="d-flex align-items-center shop-scope">
    <span class="form-label m-0 me-2 text-nowrap" style="font-size: 0.85rem;">{{ $t("content.shopgrp_viewof") }}</span>
    <select
      class="form-select shop-scope-select"
      :class="{ 'is-group': modelValue }"
      :value="modelValue ? modelValue.uid : ''"
      :disabled="disabled"
      @change="onChange" 
    >
      <option value="">{{ shopName ? `${$t("content.shopgrp_current") || 'สาขาที่เลือก'} : ${shopName}` : 'สาขาที่เลือก (ยังไม่ได้เลือกสาขา)' }}</option>
      <option v-for="g in groups" :key="g.uid" :value="g.uid">
        {{ g.name }} ({{ (g.members || []).length }} สาขา)
      </option>
    </select>
    <router-link
      class="ms-1 shop-scope-manage"
      to="/settings/shop_group"
      data-bs-toggle="tooltip"
      :title="$t('content.shopgrp_manage')"
    >
      <i class="material-icons material-symbols-outlined">settings</i>
    </router-link>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, defineProps, defineEmits } from "vue";
import { useShopGroupStore } from "@/stores/shopgroup";
import { useUserSecurityStore } from "@/stores/usersecurity";

defineProps({
  modelValue: { type: Object, default: null },
  shopName: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const sgroupStore = useShopGroupStore();
const userSStore = useUserSecurityStore();

const groups = computed(() => sgroupStore.cachedGroups);

let shopGroupChannel = null;

async function loadGroups(force = false) {
  try {
    let userUid = "";
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin") || "null");
    const token = key?.accessToken || "";
    if (token) {
      try {
        const payloadPart = token.split(".")[1]; // 🟢 ตรวจสอบตำแหน่ง array ให้ถูกต้อง [1]
        if (payloadPart) {
          const decoded = JSON.parse(atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")));
          userUid = decoded.user_uid || decoded.sub || decoded.uid || "";
        }
      } catch (errJwt) {
        console.warn("JWT decode err:", errJwt);
      }
      
      if (!userUid) {
        try {
          const resIntro = await userSStore.introspect(token);
          userUid = resIntro?.user_uid || resIntro?.data?.user_uid || "";
        } catch (errIntro) {
          console.warn("Introspect err:", errIntro);
        }
      }
    }
    
    if (force) {
      await sgroupStore.refetchGroups(userUid);
    } else {
      await sgroupStore.loadGroupsWithCache(userUid);
    }
  } catch (e) {
    console.error("loadGroups error:", e);
  }
}

// 🟢 ฟังก์ชันดักจับ: เมื่อสลับแท็บ/หน้าต่างกลับมาโฟกัสที่หน้าเว็บนี้ 
// ให้ดึงข้อมูลสดใหม่มารอในระบบทันที ไม่ต้องรอกดคลิก Dropdown
function handleWindowFocus() {
  loadGroups(true);
}

function onChange(event) {
  const uid = event.target.value;
  const selected = groups.value.find((g) => String(g.uid) === String(uid)) || null;
  emit("update:modelValue", selected);
}

onMounted(() => {
  loadGroups(false);
  window.addEventListener('focus', handleWindowFocus);

  shopGroupChannel = new BroadcastChannel('shop_group_channel');
  shopGroupChannel.onmessage = (event) => {
    if (event.data?.event === 'refresh_groups') {
      loadGroups(true); 
    }
  };
});

onUnmounted(() => {
  // 🟢 ลบ event listener ออกเมื่อทำลายคอมโพเนนต์
  window.removeEventListener('focus', handleWindowFocus);
  
  if (shopGroupChannel) {
    shopGroupChannel.close();
  }
});
</script>


<style scoped>
select.form-select.shop-scope-select {
  min-width: 220px;
  max-width: 320px;
  height: 38px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  background-color: #fff;
  cursor: pointer;
}

.shop-scope-select.is-group {
  border-color: #05af50;
  color: #05602d;
  font-weight: 700;
}

.shop-scope-manage {
  color: #7b809a;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.shop-scope-manage .material-icons {
  font-size: 20px;
}

.shop-scope-manage:hover {
  color: #05af50;
}
</style>
